import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/success-ribbons.svg';
import { USER } from '../../interfaces/auth.interface';
import { WALLET_RESPONSE } from '../../interfaces/wallet.interface';


interface Props extends PropsFromRedux {}

const WithdrawSuccess: React.FC<Props> = ({ 
    hideModal,
    showModal,
    modal,
    user,
    walletShipments,
    codHistoryState,
    getCodHistory
 }) => {

    const amount = modal?.ownProps?.amount;
    const userObj: USER = user?.response?.Object;
    const shipmentObject: WALLET_RESPONSE = walletShipments?.response?.Object;
    const [startDate, setStartDate] = React.useState<Date | null>(null);
    const [endDate, setEndDate] = React.useState<Date | null>(null);

  const closeModal = () => {
    hideModal();
      getCodHistory(
        {
            StartDate: startDate,
            EndDate: endDate,
            UserId: userObj?.UserId,
            PageSize: 50,
            Page: 1
        }
    );
  }
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-2 bg-white lg:px-20 py-10 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
         <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={checkImg} alt="GIG App" className="w-48 my-4" />
    </div>
     <div className="w-full my-4 text-center">
         <h2 className="mb-1 text-lg font-semibold text-black">Withdrawal Successful.</h2>
         <p className="text-xs text-gray-500 my-2">
             Your withdrawal of {userObj?.Country?.CurrencyCode}{amount} was successful! Your account will be credited shortly.</p>
      </div>
      {/* <button className="w-full bg-orange-600 font-medium text-sm rounded text-white py-3" type="button" onClick={() => closeModal()}>Download Stellas Bank App</button> */}
      <button className="w-full bg-gray-100 font-medium text-sm font-bold rounded text-black py-3" type="button" onClick={() => closeModal()}>View Transactions</button>
  </div>
  );
  // </ModalWrapper>
};

export default WithdrawSuccess;
